module.exports = __webpack_public_path__ + "images/embed/set_status.gif";